const songs = [
  {
    id: 1,
    anime_id: 1,
    title: "Yukitoki",
    artist: "Nagi Yanagi",
  },
  {
    id: 2,
    anime_id: 1,
    title: "Hello Alone",
    artist: "Saori Hayami, Nao Toyama",
  },
  {
    id: 3,
    anime_id: 1,
    title: "Harumodoki",
    artist: "Nagi Yanagi",
  },
  {
    id: 4,
    anime_id: 1,
    title: "Everyday World",
    artist: "Saori Hayami, Nao Toyama",
  },
  {
    id: 5,
    anime_id: 2,
    title: "again",
    artist: "YUI",
  },
  {
    id: 6,
    anime_id: 2,
    title: "Uso",
    artist: "SID",
  },
  {
    id: 7,
    anime_id: 2,
    title: "Let it out",
    artist: "Miho Fukuhara",
  },
  {
    id: 8,
    anime_id: 2,
    title: "RAY OF LIGHT",
    artist: "Shoko Nakagawa",
  },
  {
    id: 9,
    anime_id: 3,
    title: "Yasashisa no Riyu",
    artist: "ChouCho",
  },
  {
    id: 10,
    anime_id: 3,
    title: "Madoromi no Yakusoku",
    artist: "Satomi Satou, Ai Kayano",
  },
  {
    id: 11,
    anime_id: 3,
    title: "Mikansei Stride",
    artist: "Saori Kodama",
  },
  {
    id: 12,
    anime_id: 3,
    title: "Kimi ni Matsuwaru Mystery",
    artist: "Satomi Satou, Ai Kayano",
  },
  {
    id: 13,
    anime_id: 4,
    title: "departure!",
    artist: "Masatoshi Ono",
  },
  {
    id: 14,
    anime_id: 4,
    title: "Just Awake",
    artist: "Fear, and Loathing in Las Vegas",
  },
  {
    id: 15,
    anime_id: 4,
    title: "Hunting for Your Dream",
    artist: "Galneryus",
  },
  {
    id: 16,
    anime_id: 4,
    title: "REASON",
    artist: "YUZU",
  },
  {
    id: 17,
    anime_id: 4,
    title: "Nagareboshi☆KIRARI",
    artist: "YUZU",
  },
  {
    id: 18,
    anime_id: 4,
    title: "Hyori Ittai",
    artist: "YUZU",
  },
  {
    id: 19,
    anime_id: 4,
    title: "Hyouri Ittai- second version",
    artist: "YUZU",
  },
  {
    id: 20,
    anime_id: 5,
    title: "Q&A Recital!",
    artist: "Haruka Tomatsu",
  },
  {
    id: 21,
    anime_id: 5,
    title: "White wishes",
    artist: "9nine",
  },
  {
    id: 22,
    anime_id: 6,
    title: "Little Busters!",
    artist: "Rita",
  },
  {
    id: 23,
    anime_id: 6,
    title: "Alicemagic",
    artist: "Rita",
  },
  {
    id: 24,
    anime_id: 6,
    title: "Boys be Smile",
    artist: "Suzuyu",
  },
  {
    id: 25,
    anime_id: 6,
    title: "Kimi to no Nakushi Mono",
    artist: "Ayaka Kitazawa",
  },
  {
    id: 26,
    anime_id: 6,
    title: "Amenochi Hare",
    artist: "Rita",
  },
  {
    id: 27,
    anime_id: 7,
    title: "over and over",
    artist: "Nagi Yanagi",
  },
  {
    id: 28,
    anime_id: 7,
    title: "behind",
    artist: "Nagi Yanagi",
  },
  {
    id: 29,
    anime_id: 8,
    title: "Aoi Shiori",
    artist: "Galileo Galilei",
  },
  {
    id: 30,
    anime_id: 8,
    title: "Secret Base - Kimi ga Kureta Mono (10 years after Ver.)",
    artist: "Ai Kayano, Haruka Tomatsu, Saori Hayami",
  },
  {
    id: 31,
    anime_id: 9,
    title: "Perfect-area complete!",
    artist: "Natsuko Aso",
  },
  {
    id: 32,
    anime_id: 9,
    title: "Baka Go Home",
    artist: "milktub",
  },
  {
    id: 33,
    anime_id: 9,
    title: "Hare Tokidoki Egao",
    artist: "Hitomi Harada, Kaori Mizuhashi, Emiri Katou, Tomomi Isomura",
  },
  {
    id: 34,
    anime_id: 9,
    title: "Kimi + Nazo + Watashi de JUMP!!",
    artist: "Larval Stage Plannning",
  },
  {
    id: 35,
    anime_id: 10,
    title: "Here",
    artist: "JUNNA",
  },
  {
    id: 36,
    anime_id: 11,
    title: "Seishun Seminar",
    artist: "Study",
  },
  {
    id: 37,
    anime_id: 12,
    title: "Fukashigi no Karte",
    artist: "Asami Seto, Inori Minase, Maaya Uchida, Nao Toyama, Yurika Kubo",
  },
  {
    id: 38,
    anime_id: 13,
    title: "GAMERS!",
    artist: "Hisako Kanemoto, Manaka Iwami, Rumi Ookubo",
  },
  {
    id: 39,
    anime_id: 14,
    title: "Tank!",
    artist: "Seatbelts",
  },
];

export default songs;
